import { render, staticRenderFns } from "./invoiceDetails.vue?vue&type=template&id=7c3610b5&scoped=true&"
import script from "./invoiceDetails.vue?vue&type=script&lang=js&"
export * from "./invoiceDetails.vue?vue&type=script&lang=js&"
import style0 from "./invoiceDetails.vue?vue&type=style&index=0&id=7c3610b5&lang=scss&scoped=true&"
import style1 from "./invoiceDetails.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3610b5",
  null
  
)

export default component.exports